var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}],attrs:{"justify":"center","align":"baseline"}},[_c('v-icon',{attrs:{"color":_vm.color,"large":""},on:{"click":_vm.scrollToTop}},[_vm._v(_vm._s(_vm.icon))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }